import { motion, useSpring } from "framer-motion";
import { useEffect, useState } from "react";

export default function CustomCursor() {
  const [visible, setVisible] = useState(false);
  const cursorX = useSpring(-20, { stiffness: 900, damping: 45 });
  const cursorY = useSpring(-20, { stiffness: 900, damping: 45 });

  useEffect(() => {
    const moveCursor = (event) => {
      cursorX.set(event.clientX - 6);
      cursorY.set(event.clientY - 6);
      setVisible(true);
    };
    window.addEventListener("mousemove", moveCursor);
    return () => window.removeEventListener("mousemove", moveCursor);
  }, [cursorX, cursorY]);

  return (
    <motion.div
      aria-hidden="true"
      className="custom-cursor"
      data-testid="custom-cursor"
      style={{ opacity: visible ? 1 : 0, x: cursorX, y: cursorY }}
    />
  );
}